// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1876) return "static/chunks/1876-f800bbb40ecf9baf.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2185 ? "a0008d22" : chunkId) + "." + {"2185":"318eac80e3e2e647","2186":"3dcc5f157bf16480","2248":"a908c6ee392201ba","4237":"ed35d37bfa52b8dc","6077":"19e1e99700c4484f","6207":"b438ef127d559eff","8010":"25465971c9b6cb6d"}[chunkId] + ".js";
};